import { UserPreferenceContext } from '@/contexts/user-preference-context'
import { useContext } from 'react'

export const useUserPreference = (key?: string) => {
  const context = useContext(UserPreferenceContext)
  if (context === undefined) throw new Error('useUserPreference must be used within a UserPreferenceProvider')

  const userPreference = key
    ? (context.userPreferences?.find((preference) => preference.key === key) ?? null)
    : undefined

  return {
    userPreferences: context.userPreferences,
    userPreference,
    isLoading: context.isLoading,
    error: context.error,
    upsertUserPreference: context.upsertUserPreference,
  }
}
